import { h as handleRequest } from "../../../../../chunks/utils.js";
import { j as json } from "../../../../../chunks/index2.js";
import { s as stripe } from "../../../../../chunks/stripe.js";
import admin from "firebase-admin";
const GET = handleRequest(async () => {
  const checkouts = await stripe.checkout.sessions.list({
    status: "complete",
    limit: 100
  });
  for (const checkout of checkouts.data) {
    if (checkout.metadata?.id && checkout.customer_details && checkout.payment_status === "paid") {
      console.log("Found checkout session: ", checkout.id);
      console.log("User ID: ", checkout.metadata?.id);
      console.log("User email: ", checkout.customer_details.email);
      const userRef = admin.firestore().collection("users").doc(checkout.metadata.id);
      const user = await userRef.get();
      if (user.exists) {
        const data = user.data();
        console.log("Found user: ", data);
        if (data) {
          if (Object.keys(data).length === 3) {
            console.log("User is malformed.");
            const staleUserRef = admin.firestore().collection("users").doc(`${checkout.metadata.id}@glimmr.com`);
            const staleUser = await staleUserRef.get();
            if (staleUser.exists) {
              console.log("Found stale user with @glimmr.com email");
              const updatedUser = {
                ...staleUser.data(),
                ...data,
                email: checkout.customer_details.email,
                license: "premium",
                trialAvailability: false,
                trialStartDate: null
              };
              await userRef.set(updatedUser);
              console.log("Merging user...", updatedUser);
              await staleUserRef.delete();
              console.log("Deleting old user...");
            }
          }
        }
      }
    }
  }
  return json({
    success: true
  });
});
export {
  GET
};
